import React, { useContext } from 'react';
import LanguageContext from '../context/LanguageContext';
import IntroductionContext from '../context/IntroductionContext';
import { getLocalizedContent, getTextDirection } from '../utils/languageUtils';

const AboutModal = ({ isOpen, onClose }) => {
    const { language } = useContext(LanguageContext);
    const { introduction } = useContext(IntroductionContext);
    
    if (!isOpen) return null;

    // Get localized content
    const title = language === 'persian' ? 'درباره ما' : 'About Us';
    const content = getLocalizedContent(
        introduction?.english_about_us || `Welcome to the Qajar Codices project, an initiative dedicated to the 
intellectual legacy of Iranian thinkers during the long nineteenth 
century. Our primary mission is to make accessible the thought that 
characterized the Qajar era by collecting, digitizing, and transcribing 
Qajar manuscripts.

This platform seeks to provide scholars of modern 
Iran with resources, including transcriptions, translations, audio 
renderings, and annotated glossaries. Through our efforts, we aim to 
preserve and present the voices that shaped Iran's intellectual and 
political evolution before and during the constitutional era.

The initial focus of this project centers on Mirza Agha Khan 
Kermani, a pivotal intellectual, journalist, social critic, and political 
activist of the mid- and late-Qajar period. We are also planning to 
expand our collection to include other influential figures of 
nineteenth-century Iranian thought, such as Mirza Malkum Khan, 
Akhundzadeh, Mostashar al-Dowleh, Talebov, and Maragheei.`,
        introduction?.persian_about_us,
        language
    );

    const textDirection = getTextDirection(language);

    return (
        <>
            <div className="about-modal-overlay" onClick={onClose} />
            <div className="about-modal">
                <div className="about-modal__header">
                    <h3 
                        className="about-modal__title"
                        dir={textDirection}
                    >
                        {title}
                    </h3>
                    <button 
                        className="about-modal__close" 
                        onClick={onClose}
                        aria-label="Close about modal"
                    >
                        ×
                    </button>
                </div>
                
                <div className="about-modal__content">
                    <div 
                        className="about-modal__text"
                        dir={textDirection}
                    >
                        {content.split('\n\n').map((paragraph, index) => (
                            <p key={index}>{paragraph}</p>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default AboutModal; 